import { render, staticRenderFns } from "./ButtonSlider.vue?vue&type=template&id=0beea160&scoped=true&"
import script from "./ButtonSlider.vue?vue&type=script&lang=js&"
export * from "./ButtonSlider.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSlider.vue?vue&type=style&index=0&id=0beea160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beea160",
  null
  
)

export default component.exports